import { useEffect } from "react";

function Modal({ text, timeout, onClose }: { text: string, timeout: number, onClose: () => void }){

    useEffect(() => {
        const timeoutId = setTimeout(onClose, 5000);
        
        return function cleanup() {
          clearTimeout(timeoutId);
        }
      }, []);
  
    return (
        <div className="fixed top-0 inset-x-0 text-center bg-slate-400" >
            <div>
                {text}
            </div>
        </div>
    );

};

export default Modal;